/**
 * crewConstants.js — Crew rate categories & lookup
 *
 * Single source of truth for hourly rate categories.
 * Rates stored in settings.data.crewRates[crewId][category].
 */

export const RATE_CATEGORIES = ['production', 'post_production', 'admin'];

/**
 * Look up a crew member's hourly rate for a given category.
 *
 * @param {object} settings — settings object from useSettings() (shape: { data: {...} })
 * @param {string} crewId  — crew_id from roster
 * @param {string} category — one of RATE_CATEGORIES
 * @returns {number|null}
 */
export function getCrewRate(settings, crewId, category) {
  return settings?.data?.crewRates?.[crewId]?.[category] ?? null;
}
